var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orders-list-table Is" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.dataList,
            "header-cell-style": { background: "#fafafa", color: "#333333" },
          },
        },
        [
          _vm._l(
            _vm.config,
            function ({ type, prop, label, width, slot, align, fixed }) {
              return [
                slot
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        fixed: fixed,
                        align: align,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                slot === "goods"
                                  ? [
                                      scope.row.orderDetailAfterInfo
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "itemN",
                                              style: {
                                                zIndex: 100 - scope.$index,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "order_details",
                                                  staticStyle: {
                                                    "padding-top": "8px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order_details_box",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order_details_item",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order_details_title",
                                                            },
                                                            [_vm._v("售后状态")]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "margin-left":
                                                                  "8px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .orderDetailAfterInfo
                                                                    .orderAfterStatusLabel
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("div", {
                                                    staticClass: "blankBox",
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order_details_box",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order_details_item",
                                                          staticStyle: {
                                                            display: "flex",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "order_details_title",
                                                              staticStyle: {
                                                                "margin-top":
                                                                  "20px",
                                                              },
                                                            },
                                                            [_vm._v("售后编号")]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-left":
                                                                  "8px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .orderDetailAfterInfo
                                                                    .orderAfterNo
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-left":
                                                                  "8px",
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.copy(
                                                                      scope.row
                                                                        .orderDetailAfterInfo
                                                                        .orderAfterNo
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticStyle: {
                                                                  width: "16px",
                                                                  height:
                                                                    "16px",
                                                                  "padding-top":
                                                                    "12px",
                                                                },
                                                                attrs: {
                                                                  src: require("../../../assets/icon_fuzhi.png"),
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-left":
                                                                  "8px",
                                                                color:
                                                                  "#2D46EE",
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.copy(
                                                                      scope.row
                                                                        .orderDetailAfterInfo
                                                                        .orderAfterNo
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("复制")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("div", {
                                                    staticClass: "blankBox",
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order_details_box",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order_details_item",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order_details_title",
                                                            },
                                                            [_vm._v("售后说明")]
                                                          ),
                                                          _c("span", {
                                                            staticStyle: {
                                                              "margin-left":
                                                                "8px",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .orderDetailAfterInfo
                                                                .remark || "--"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "order_details",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order_details_box",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order_details_item",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "order_details_title",
                                                            },
                                                            [_vm._v("审核时间")]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "margin-left":
                                                                  "8px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row
                                                                    .orderDetailAfterInfo
                                                                    .approveTime ||
                                                                    "--"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("div", {
                                                    staticClass: "blankBox",
                                                  }),
                                                  scope.row.orderDetailAfterInfo
                                                    .orderAfterStatusLabel ==
                                                    "退货退款中" ||
                                                  scope.row.orderDetailAfterInfo
                                                    .orderAfterStatusLabel ==
                                                    "退货退款已完成"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order_details_box",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "order_details_item",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "order_details_title",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "退回金额"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "8px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      Number(
                                                                        scope
                                                                          .row
                                                                          .orderDetailAfterInfo
                                                                          .refundMoney
                                                                      ).toFixed(
                                                                        2
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  scope.row.orderDetailAfterInfo
                                                    .orderAfterStatus == 2
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order_details_box",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "order_details_item",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "order_details_title",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "驳回备注"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "8px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      scope.row
                                                                        .orderDetailAfterInfo
                                                                        .approveRemark
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          style: {
                                            "padding-bottom": scope.row
                                              .orderDetailAfterInfo
                                              ? "120px"
                                              : "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-align": "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.goodsName)
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-align": "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "规格:" +
                                                  _vm._s(scope.row.goodsSkuName)
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-align": "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "商品编号:" +
                                                  _vm._s(scope.row.goodsSkuNo)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "retailPrice"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          style: {
                                            "padding-bottom": scope.row
                                              .orderDetailAfterInfo
                                              ? "120px"
                                              : "10px",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              "￥" +
                                                _vm._s(
                                                  Number(
                                                    scope.row.retailPrice
                                                  ).toFixed(2)
                                                )
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              "x" +
                                                _vm._s(scope.row.goodsQuantity)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "freightAmount"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          style: {
                                            "padding-bottom": scope.row
                                              .orderDetailAfterInfo
                                              ? "120px"
                                              : "10px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "￥" +
                                              _vm._s(
                                                Number(
                                                  scope.row.freightAmount
                                                ).toFixed(2)
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "totalAmount"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          style: {
                                            "padding-bottom": scope.row
                                              .orderDetailAfterInfo
                                              ? "120px"
                                              : "10px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "实付￥" +
                                              _vm._s(
                                                Number(
                                                  scope.row.totalAmount
                                                ).toFixed(2)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "preferential"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          style: {
                                            "padding-bottom": scope.row
                                              .orderDetailAfterInfo
                                              ? "120px"
                                              : "10px",
                                          },
                                        },
                                        [_vm._v("￥0.00")]
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
              ]
            }
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }